import React, { Component, PureComponent } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import { TableComp } from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import { Button, Card, Form, Row, Col, DatePicker, Drawer, notification, Tooltip, Popconfirm } from 'antd'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import _ from 'lodash'
import ApplyLeave from '../../components/_utils/leaveapplication';
import Request, { API_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'


const { MonthPicker } = DatePicker

@Form.create()
class HandoverForm extends Component {
    state = {
        otherCredentials: false,
        anyFinanceDues: false
    }

    loadData = async () => {
        let { record } = this.props
        let response = await Request.getResignDataById(record._id);
        let { data } = response
        setTimeout(() => {
            this.props.form.setFieldsValue({
                ...data[0]
            })
        }, 500)
    }
    componentDidMount() {
        this.loadData()
    }

    handleSubmit = (e) => {
        let { form, dispatch, handleSubmit } = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                handleSubmit(values)
            }
        })
    }

    render() {

        let { otherCredentials, anyFinanceDues } = this.state
        const inputTypes = {
            fields: [
                {
                    label: 'Job Responsibilities/Projects',
                    key: 'jobResponsibilitiesOrProjects',
                    type: 'textarea'
                },
                {
                    label: 'Status of Ongoing Projects/Work',
                    key: 'statusOngoingProjectsOrWork',
                    type: 'textarea'
                },
                {
                    label: 'Pending Tasks and Deadlines',
                    key: 'pendingTasksAndDeadLines',
                    type: 'textarea'
                },
                {
                    label: 'Official Email Id',
                    key: 'officialEmail',
                    type: 'text',
                    prefixComp: "Access & Permissions:-"
                },
                {
                    label: 'Official Email Password',
                    key: 'officalEmailPass',
                    type: 'text'
                },
                {
                    label: 'Official Phone Number',
                    key: 'officialPhone',
                    type: 'text'
                },
                {
                    label: 'Official Laptop/Desktop',
                    key: 'officialLaptopOrDesktop',
                    type: 'text',
                },
                {
                    label: 'Official Laptop/Desktop Password',
                    key: 'officialLaptopOrDesktopPass',
                    type: 'text'
                },
                {
                    label: 'Laptop’s Charger',
                    key: 'laptopCharger',
                    type: 'select',
                    options: ['Submitted', 'Not Submitted'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ laptopCharger: v })
                    }
                },
                {
                    label: 'Headphones',
                    key: 'headphones',
                    type: 'select',
                    options: ['Submitted', 'Not Submitted', 'Do Not Have'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ headphones: v })
                    }
                },
                {
                    label: 'Mouse',
                    key: 'mouse',
                    type: 'select',
                    options: ['Submitted', 'Not Submitted', 'Do Not Have'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ mouse: v })
                    }
                },
                {
                    label: 'Any other credentials',
                    key: 'anyOtherCredentials',
                    type: 'select',
                    options: ['Yes', "No"],
                    onChange: v => {
                        this.props.form.setFieldsValue({ anyOtherCredentials: v })
                        if (v === 'Yes') {
                            this.setState({ otherCredentials: true })
                        } else if (v === 'No') {
                            this.setState({ otherCredentials: false })
                        }
                    }
                },
                {
                    label: 'Please Mention Here',
                    key: 'credentialsSpecify',
                    type: 'textarea',
                    hidden: !otherCredentials,
                },
                {
                    label: 'Key Contacts and Relationships',
                    key: 'keyContactsAndRelationships',
                    type: 'textarea',
                    placeholder: 'List important contacts, both internal and external, and any relationships that the new contact person should be aware of'
                },
                {
                    label: 'Documentation and Files',
                    key: 'documentationAndFiles',
                    type: 'textarea',
                    placeholder: 'Provide details about the location of relevant documents, files, and folders. Include any cloud storage, network drives, or physical files.'
                },
                {
                    label: 'Software and Tools',
                    key: 'softwareAndTools',
                    type: 'textarea',
                    placeholder: 'List any specialized software, tools, or systems the new contact person will need to use and provide instructions for access if necessary.'
                },
                {
                    label: 'Backup and Deletion of Email ID',
                    key: 'backupAndDeletionEmailId',
                    type: 'select',
                    options: ['Done', 'Not Done'],
                    prefixComp: 'IT:-',
                    onChange: v => {
                        this.props.form.setFieldsValue({ backupAndDeletionEmailId: v })
                    }
                },
                {
                    label: 'Deletion from every official group',
                    key: 'deletionOfficialGroup',
                    type: 'select',
                    options: ['Done', 'Not Done'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ deletionOfficialGroup: v })
                    }
                },
                {
                    label: 'Biometric Deactivation',
                    key: 'biometricDeactivation',
                    type: 'select',
                    options: ['Done', 'Not Done'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ biometricDeactivation: v })
                    }
                },
                {
                    label: 'Any Drawer or Locker Keys',
                    key: 'drawerOrLockerKeys',
                    type: 'select',
                    options: ['Submitted', 'Not Submitted', 'Do Not Have'],
                    prefixComp: 'HR:-',
                    onChange: v => {
                        this.props.form.setFieldsValue({ drawerOrLockerKeys: v })
                    }
                },
                {
                    label: 'Identity Card',
                    key: 'identityCard',
                    type: 'select',
                    options: ['Submitted', 'Not Submitted', 'Do Not Have'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ identityCard: v })
                    }
                },
                {
                    label: 'Any dues',
                    key: 'anyDues',
                    type: 'select',
                    options: ['Yes', 'No'],
                    prefixComp: 'Finance:-',
                    onChange: v => {
                        this.props.form.setFieldsValue({ anyDues: v })
                        if (v === 'Yes') {
                            this.setState({ anyFinanceDues: true })
                        } else if (v === "No") {
                            this.setState({ anyFinanceDues: false })
                        }
                    }
                },
                {
                    label: 'Please Specify',
                    key: 'duesSpecify',
                    type: 'textarea',
                    hidden: !anyFinanceDues
                },
                {
                    label: 'Additional Notes',
                    key: 'additionalNotes',
                    type: 'textarea',
                    prefixComp: 'Other:-',
                    placeholder: "Include any additional information, instructions, or comments that will help with the transition. If there are specific handover meetings scheduled, mention them here.",
                },
                {
                    label: 'Any Other File',
                    key: 'otherFiles',
                    type: 'file',
                    limit: 4
                }
            ]
        }




        // const inputTypes = {
        //     fields:[
        //         {
        //             label:'Job Responsibilities/Projects',
        //             key:'jobResponsibilitiesOrProjects',
        //             type:'textarea'
        //         },
        //         {
        //             label:'Status of Ongoing Projects/Work',
        //             key:'statusOngoingProjectsOrWork',
        //             type:'textarea'
        //         },
        //         {
        //             label:'Pending Tasks and Deadlines',
        //             key:'pendingTasksAndDeadLines',
        //             type:'textarea'
        //         },
        //         {
        //             label:'Official Email Id',
        //             key:'officialEmail',
        //             type:'text',
        //             prefixComp:"Access & Permissions:-"
        //         },
        //         {
        //             label:'Official Email Password',
        //             key:'officalEmailPass',
        //             type:'text'
        //         },
        //         {
        //             label:'Official Phone Number',
        //             key:'officialPhone',
        //             type:'text'
        //         },
        //         {
        //             label:'Official Laptop/Desktop',
        //             key:'officialLaptopOrDesktop',
        //             type:'text',
        //         },
        //         {
        //             label:'Official Laptop/Desktop Password',
        //             key:'officialLaptopOrDesktopPass',
        //             type:'text'
        //         },
        //         {
        //             label:'Laptop’s Charger',
        //             key:'laptopCharger',
        //             type:'text'
        //         },
        //         {
        //             label:'Headphones',
        //             key:'headphones',
        //             type:'text'
        //         },
        //         {
        //             label:'Mouse',
        //             key:'mouse',
        //             type:'text'
        //         },
        //         {
        //             label:'Any other credentials',
        //             key:'anyOtherCredentials',
        //             type:'textarea'
        //         },
        //         {
        //             label:'Key Contacts and Relationships',
        //             key:'keyContactsAndRelationships',
        //             type:'textarea',
        //             placeholder:'List important contacts, both internal and external, and any relationships that the new contact person should be aware of'
        //         },
        //         {
        //             label:'Documentation and Files',
        //             key:'documentationAndFiles',
        //             type:'textarea',
        //             placeholder:'Provide details about the location of relevant documents, files, and folders. Include any cloud storage, network drives, or physical files.'
        //         },
        //         {
        //             label:'Software and Tools',
        //             key:'softwareAndTools',
        //             type:'textarea',
        //             placeholder:'List any specialized software, tools, or systems the new contact person will need to use and provide instructions for access if necessary.'
        //         },
        //         {
        //             label:'Backup and Deletion of Email ID',
        //             key:'backupAndDeletionEmailId',
        //             type:'textarea',
        //             prefixComp:'IT:-'
        //         },
        //         {
        //             label:'Deletion from every official group',
        //             key:'deletionOfficialGroup',
        //             type:'text'
        //         },
        //         {
        //             label:'Biometric Deactivation',
        //             key:'biometricDeactivation',
        //             type:'text'
        //         },
        //         {
        //             label:'Any Drawer or Locker Keys',
        //             key:'drawerOrLockerKeys',
        //             type:'text',
        //             prefixComp:'HR:-'
        //         },
        //         {
        //             label:'Identity Card',
        //             key:'identityCard',
        //             type:'text'
        //         },
        //         {
        //             label:'Any dues',
        //             key:'anyDues',
        //             type:'text',
        //             prefixComp:'Finance:-'
        //         },
        //         {
        //             label:'Additional Notes',
        //             key:'additionalNotes',
        //             type:'textarea',
        //             prefixComp:'Other:-',
        //             placeholder:"Include any additional information, instructions, or comments that will help with the transition. If there are specific handover meetings scheduled, mention them here.",
        //         }
        //     ]
        // }
        const {
            form: { getFieldDecorator }
        } = this.props
        return (
            <Card>
                <Form onSubmit={this.handleSubmit}>
                    <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} apiurl={API_URL} />
                    <Row style={{ marginTop: '20px' }}>
                        <Col span={8} />
                        <Col span={8}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ marginBottom: 10 }}
                                loading={this.props.loading}>
                                Save
                            </Button>
                        </Col>
                        <Col span={8} />
                    </Row>
                </Form>
            </Card>
        )
    }
}

@Form.create()
class ResignationForm extends Component {
    state = {
        hodList: []
    }

    getCurrentUser = () => {
        let response = JSON.parse(localStorage.getItem('user'))
        return response
    }

    loadUsers = async () => {
        let response = await Request.getDepartmentHod()
        let hodList = []
        if (response.length) {
            _.each(response, (item) => {
                hodList.push({ _id: item._id, display: item.name })
            })
            this.setState({ hodList })
        }

    }

    async componentDidMount() {
        this.loadUsers()
    }

    handleSubmit = (e) => {
        const { form, dispatch, handleSubmit } = this.props
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                handleSubmit(values)
            }
        })
    }

    render() {

        const {
            form: { getFieldDecorator }
        } = this.props
        const { hodList } = this.state

        const inputTypes = {
            fields: [
                {
                    label: 'Resignation Reason',
                    type: 'editor',
                    key: 'resignationReason',
                    required: true
                },
                {
                    label: 'Choose Your Manager',
                    type: 'select',
                    key: 'manager',
                    showSearch: true,
                    options: hodList,
                    onChange: v => {
                        this.props.form.setFieldsValue({ manager: v })
                    }
                }
            ]
        }
        return (
            <Card>
                <Form style={{ marginTop: 8 }} onSubmit={this.handleSubmit}>
                    <div>
                        <GetAllFormFields
                            apiurl={API_URL}
                            inputSchema={inputTypes}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </div>
                    <Row style={{ marginTop: '20px' }}>
                        <Col span={8} />
                        <Col span={8}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ marginBottom: 10 }}
                                loading={this.props.loading}>
                                Save
                            </Button>
                        </Col>
                        <Col span={8} />
                    </Row>
                </Form>
            </Card>
        )
    }
}

@Form.create()
class ServeNotice extends PureComponent {
    state = {
        studentId: '',
        count: 0,
        month: moment(),
        defaultPageSize: 20,
        activityArr: [],
        oldLeaves: [],
        showResignationForm: false,
        sandwichLeaves: 0,
        casualLeaves: 0,
        leavesWithoutPay: 0,
        leavesWithoutNotice: 0,
        record: [],
        showHandoverForm: false,
    }



    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }

    async getLeaveDetails() {
        let currentUser = JSON.parse(localStorage.getItem('user'));
        let sandwichLeaveDetails = await this.getSandwichLeaveDetails(currentUser._id);
        let casualLeaveDetails = await this.getCasualLeaveDetails(currentUser._id);
        let leaveWithoutPayDetails = await this.getLeaveWithoutPayDetails(currentUser._id);
        let leaveWithoutNoticeDetails = await this.getLeaveWithoutNoticeDetails(currentUser._id)
        this.setState({ sandwichLeaves: sandwichLeaveDetails.total, casualLeaves: casualLeaveDetails.total, leavesWithoutPay: leaveWithoutPayDetails.total, leavesWithoutNotice: leaveWithoutNoticeDetails.total })
    }

    async getSandwichLeaveDetails(userId) {
        let data = {
            userId: userId,
            leaveType: 'Sandwich Leave',
            leaveYear: moment(this.state.month).format('YYYY')
        }

        let response = await Request.getUserLeaves(data);
        return response
    }
    async getCasualLeaveDetails(userId) {
        let data = {
            userId: userId,
            leaveType: 'CL(Casual Leave)',
            leaveYearMonth: moment(this.state.month).format('YYYY-MM')
        }
        let response = await Request.getUserLeaves(data);
        return response
    }

    async getLeaveWithoutPayDetails(userId) {
        let data = {
            userId: userId,
            leaveType: 'LWP(Leave Without Pay)',
            leaveYearMonth: moment(this.state.month).format('YYYY-MM')
        }
        let response = await Request.getUserLeaves(data);
        return response
    }

    async getLeaveWithoutNoticeDetails(userId) {
        let data = {
            userId: userId,
            leaveType: 'LWN(Leave Without Notice)',
            leaveYearMonth: moment(this.state.month).format('YYYY-MM')
        }
        let response = await Request.getUserLeaves(data);
        return response
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    handleResignationClick = () => {
        this.setState({ showResignationForm: true })
    }

    handleHandoverForm = (data) => {
        this.setState({ record: data, showHandoverForm: true })
    }

    handleApplicationClose = () => {
        this.setState({ showApplicationForm: false })
        this.table.current.reload()
    }

    apiRequest = params => {
        return new Promise(async (resolve) => {
            let response = await Request.getUserResignations(params);
            this.setState({ count: response.total })
            resolve(response)
        })
    }

    handleMonthChange = (month) => {
        this.setState({ month: moment(month) }, () => {
            this.reload()
        })
    }

    reload = () => {
        this.table.current.reload()
    }

    componentDidMount() {
        this.getLeaveDetails();
    }

    render() {
        const { defaultPageSize, record, showHandoverForm, showResignationForm, count, oldLeaves, sandwichLeaves, casualLeaves, leavesWithoutPay, leavesWithoutNotice } = this.state
        const columns = [
            {
                title: 'Resignation Date',
                key: 'resignationDate',
                render: (val, record) => (
                    <div>
                        {moment(record.resignationDate).format("DD-MM-YYYY")}
                    </div>
                )
            },
            {
                title: 'Manager/HOD',
                key: 'manager.name',
            },
            {
                title: 'Last Working Date',
                key: 'lastWorkingDate',
                render: (val, record) => (
                    <div>
                        {record.lastWorkingDate ? moment(record.lastWorkingDate).format("DD-MM-YYYY") : null}
                    </div>
                )
            },
            {
                title: 'Created/Updated By',
                key: 'updatedByUser.name',
                render: (text, record) => {
                    if (!record.updatedByUser) {
                        return (
                            <div>{record.createdByUser.name}</div>
                        )
                    } else {
                        return (
                            <div>{record.updatedByUser.name}</div>
                        )
                    }
                }
            },
            {
                title: 'Status',
                key: 'status',
                render: (text, record) => {
                    if (text === 'Approved') {
                        return (
                            <div style={{ background: 'green', color: 'white' }}>{text}</div>
                        )
                    } else if (text === 'Disapproved') {
                        return (
                            <div style={{ background: 'red', color: 'white' }}>{text}</div>
                        )
                    } else {
                        return (
                            <div style={{ background: 'yellow' }}>{text}</div>
                        )
                    }
                }
            },
            {
                title: 'Action',
                key: 'operation',
                dataIndex: 'operation',
                render: (val, record) => {
                    if (!record.lastWorkingDate) {
                        return null
                    }
                    let lastWorkingDate = moment(record.lastWorkingDate).format('DD-MM-YYYY')
                    if (lastWorkingDate === moment().format('DD-MM-YYYY')) {
                        return (
                            <React.Fragment>
                                <Tooltip>
                                    <Button size={"small"} shape='circle' icon="forward" onClick={() => this.handleHandoverForm(record)} />
                                </Tooltip>
                            </React.Fragment>
                        )
                    }
                }
            }
        ]


        return (
            <PageHeaderWrapper title={`Resignation:- ${count}`}>
                {/* {
                showApplicationForm?
                    <ApplyLeave oldLeaves={oldLeaves} onClose={this.handleApplicationClose} />
                :null
            } */}
                <Card bordered={true}>
                    <Row>
                        <Col span={2}>
                            <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                <Popconfirm title="Are you Sure you want to Resign?"
                                    onConfirm={this.handleResignationClick}>
                                    <Button>Add Resignation</Button>
                                </Popconfirm>
                            </div>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true} >
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: defaultPageSize,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
                <Drawer
                    title="Add Resignation"
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            showResignationForm: false
                        })
                    }}
                    visible={showResignationForm}
                    width={600}>
                    <ResignationForm loading={this.props.loading} handleSubmit={async values => {
                        let response = await Request.addResignation(values)
                        if (!response.error) {
                            notification.success({
                                message: response.message
                            })
                            this.setState({ showResignationForm: false })
                            this.reload()
                        } else {
                            notification.error({
                                message: response.message
                            })
                            this.setState({ showResignationForm: false })
                        }
                    }} />
                </Drawer>
                <Drawer
                    title="Fill HandOver Details"
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            showHandoverForm: false
                        })
                    }}
                    visible={showHandoverForm}
                    width={800}>
                    <HandoverForm loading={this.props.loading} record={record} handleSubmit={async values => {
                        values._id = record._id
                        let response = await Request.updateResignation(values);
                        if (!response.error) {
                            notification.success({
                                message: response.message
                            })
                            this.setState({ showHandoverForm: false, record: null })
                            this.reload()
                        } else {
                            notification.error({
                                message: response.message
                            })
                            this.setState({ showHandoverForm: false })
                        }
                    }} />
                </Drawer>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ServeNotice)
